"use strict";

function deferred() {
  var result = {};
  result.promise = new Promise(function (resolve, reject) {
    result.resolve = resolve;
    result.reject = reject;
  });
  return result;
}

module.exports = deferred;


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/utils/deferred.js
// module id = G4PL
// module chunks = 88